import {useCallback} from 'react';

import {eventManager} from '@application/Event';
import {UserEvent} from '@domain/model/Event';
import {removeAuth} from '@infra/api/authManager/authManager';
import {CookieStorage} from '@infra/api/CookieStorage/CookieStorage';
import {SessionStorage} from '@infra/api/SessionStorage/SessionStorage';
import {COMMENT_ID, NEXT_BOX_DATE_ID, SUSBSCRIPTION_STORAGE_ID} from '@views/Order/PlaceOrder/PlaceOrder.definition';
import {useApp} from '@app';
import {useOverallInfo} from '@components/_context';

const removeStoredInfo = (): void => {
  CookieStorage.remove(SUSBSCRIPTION_STORAGE_ID);
  SessionStorage.removeItem(NEXT_BOX_DATE_ID);
  SessionStorage.removeItem(COMMENT_ID);
};

interface UseLogoutFunction {
  (): () => Promise<void>;
}

const useLogout: UseLogoutFunction = () => {
  const {setAuthorization} = useApp();
  const {resetState} = useOverallInfo();

  return useCallback(async (): Promise<void> => {
    await removeAuth();
    eventManager.emit(UserEvent.LOGOUT);
    setAuthorization(false);
    resetState();
    removeStoredInfo();
  }, [resetState, setAuthorization]);
};

export {useLogout};
